// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"fXhdc","iconButton":"atOX6","iconSuccess":"V_Q5b","success-icon":"Fqo5V","footerEnterButton":"f3XjR"};